import { render, staticRenderFns } from "./DashboardSettingsView.vue?vue&type=template&id=0bf2fb8b&scoped=true&"
import script from "./DashboardSettingsView.vue?vue&type=script&lang=js&"
export * from "./DashboardSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSettingsView.vue?vue&type=style&index=0&id=0bf2fb8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2fb8b",
  null
  
)

/* custom blocks */
import block0 from "./DashboardSettingsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports